export default __webpack_public_path__ + "static/media/border-all.0344ed3b.svg";